import React from 'react';
import { TextField, Checkbox, FormControlLabel, Grid } from '@mui/material';

const AdditionalInformation = ({ formData, setFormData }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              name="openToContractualOpportunities"
              checked={formData.openToContractualOpportunities || false}
              onChange={handleCheckboxChange}
            />
          }
          label="Open to Contractual Opportunities?"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Availability for Interview (Days & Time Slots)"
          name="availabilityForInterview"
          value={formData.availabilityForInterview || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Referral Code (If Any)"
          name="referralCode"
          value={formData.referralCode || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Additional Comments"
          name="additionalComments"
          value={formData.additionalComments || ''}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
};

export default AdditionalInformation;